module.exports = __webpack_public_path__ + "img/use-process-2.8c201e60.png";